import { render, staticRenderFns } from "./PatientEditForm.vue?vue&type=template&id=320c28ab&scoped=true"
import script from "./PatientEditForm.vue?vue&type=script&lang=js"
export * from "./PatientEditForm.vue?vue&type=script&lang=js"
import style0 from "./PatientEditForm.vue?vue&type=style&index=0&id=320c28ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c28ab",
  null
  
)

export default component.exports